module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "路径分析",
      "tip": "路径分析报告帮助您深入洞察用户访问或点击行为，发现并监测关键转化路径，进而进行路径优化，提升转化率"
    }
  }, [(_vm.currentView == 'analysis') ? _c('span', {
    staticClass: "floatr"
  }, [_c('label', [_vm._v("路径名称：")]), (_vm.pathList.length == 0) ? _c('v-input', {
    attrs: {
      "disabled": true,
      "placeholder": "未设置路径"
    }
  }) : _vm._e(), (_vm.pathList.length > 0) ? _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPathId),
      expression: "currentPathId"
    }],
    attrs: {
      "options": _vm.pathList
    },
    domProps: {
      "value": (_vm.currentPathId)
    },
    on: {
      "input": [function($event) {
        _vm.currentPathId = $event
      }, _vm.changePathId]
    }
  }) : _vm._e()], 1) : _vm._e()]), _c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabViews), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentView === item.comp
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeViewTo(item.comp)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), (_vm.currentView == 'analysis') ? _c('div', [_c('div', {
    staticClass: "time"
  }, [_c('TimeSpan', {
    attrs: {
      "filters": "yesterday"
    },
    on: {
      "change": _vm.onTimespanChange
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }), _c('table', {
    staticClass: "data-table"
  }, [_c('tr', [_c('td', {
    staticClass: "chart-path",
    staticStyle: {
      "padding": "20px 0px 20px 30px",
      "vertical-align": "top"
    },
    attrs: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "total-conv"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.totalRate)))]), _vm._l((_vm.stepTrateList), function(info) {
    return _c('div', {
      staticClass: "path-conv-line"
    }, [(!_vm.isRateShow(info)) ? _c('div', {
      staticClass: "conv-name",
      class: info.classname
    }, [_vm._v(_vm._s(info.name))]) : _vm._e(), (!_vm.isRateShow(info)) ? _c('div', {
      staticClass: "conv-mount"
    }, [_c('div', [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.prefix === 'UV'),
        expression: "prefix === 'UV'"
      }],
      style: ({
        'margin-right': '7px',
        'vertical-align': 'middle'
      }),
      attrs: {
        "src": "http://p1.qhimg.com/t01b24d917730ef1175.png"
      }
    }), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.prefix === '访问'),
        expression: "prefix === '访问'"
      }],
      style: ({
        'margin-right': '7px',
        'vertical-align': 'top'
      }),
      attrs: {
        "src": "http://p4.qhimg.com/t01d593ed1a7672dd5f.png"
      }
    }), _c('span', {
      staticStyle: {
        "color": "#a1b1be",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(info.prefix))])]), _c('div', {
      staticStyle: {
        "color": "#596980",
        "margin-top": "5px",
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(info.tnum))])]) : _vm._e(), (_vm.isRateShow(info)) ? _c('div', {
      staticClass: "path-radio-v",
      class: info.classname
    }, [_vm._v(_vm._s(_vm._f("percentage")(info.trate)))]) : _vm._e()])
  })], 2), _c('td', {
    attrs: {
      "width": "70%"
    }
  }, [_c('LineChart', {
    attrs: {
      "legend": _vm.legend,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": _vm.tableTabTitle
    }
  }), _c('div', {
    staticClass: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist
    }
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    },
    slot: "extentTab"
  }) : _vm._e(), _c('div', {
    slot: "funnel"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sdimOptions.length > 0),
      expression: "sdimOptions.length > 0"
    }],
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.getTableData()
      }
    }
  })], 1), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")])])])], 1)], 1), _c('complex-table', {
    attrs: {
      "classname": "report-path data-table",
      "columns": _vm.columns,
      "list": _vm.tableDataList,
      "sum": {},
      "checkbox": _vm.hasCheckBox,
      "checkbox_length": _vm.checkboxLength
    }
  }), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pg,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getTableData
    }
  }) : _vm._e()], 1)]) : _vm._e(), (_vm.currentView == 'setting') ? _c('div', {
    staticClass: "marginTop"
  }, [_c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    staticClass: "bdb",
    attrs: {
      "icon": "fa fa-list",
      "title": "路径列表"
    }
  }), _c('div', {
    staticClass: "toolbar-row"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    on: {
      "click": _vm.openSettingMadol
    }
  }, [_vm._v("转化路径设置")])]), _c('table', {
    staticClass: "data-table"
  }, [_vm._m(0), (_vm.pathList.length == 0) ? _c('tbody', [_vm._m(1)]) : _vm._e(), (_vm.pathList.length > 0) ? _c('tbody', _vm._l((_vm.pathList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _c('td', [_vm._v(_vm._s(item.createtime))]), _c('td', [_c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.changeToFunnel(item)
        }
      }
    }, [_vm._v("查看漏斗")]), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.currentStepInfo(item)
        }
      }
    }, [_vm._v("详情")]), _c('div', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          _vm.removeStepInfo(item, index)
        }
      }
    }, [_vm._v("删除")])])])
  })) : _vm._e()])], 1)]) : _vm._e(), _c('v-modal', {
    ref: "formModal",
    attrs: {
      "visible": _vm.pathSettingVisible,
      "title": '转化路径设置',
      "subTitle": '(转化路径步骤最少设置2步，最多可设置5步)'
    },
    on: {
      "closemodal": _vm.closeMadol
    }
  }, [_c('div', {
    staticClass: "modal-bd"
  }, [_c('div', {
    staticClass: "modal-content convert-path"
  }, [_c('v-form', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pathSetting),
      expression: "pathSetting"
    }],
    ref: "pathform",
    domProps: {
      "value": (_vm.pathSetting)
    },
    on: {
      "input": function($event) {
        _vm.pathSetting = $event
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("路径名称：")]), _c('div', {
    staticClass: "control"
  }, [(_vm.steplist.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.pathSetting.name))]) : _vm._e(), (_vm.steplist.length == 0) ? _c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pathSetting.name),
      expression: "pathSetting.name"
    }],
    attrs: {
      "placeholder": "请输入1-10字符名称",
      "rules": _vm.rules.name
    },
    domProps: {
      "value": (_vm.pathSetting.name)
    },
    on: {
      "input": function($event) {
        _vm.pathSetting.name = $event
      }
    },
    nativeOn: {
      "input": function($event) {
        _vm.pathSettingNameMsg = ''
      }
    }
  }) : _vm._e(), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pathSettingNameMsg != ''),
      expression: "pathSettingNameMsg != ''"
    }]
  }, [_vm._v(_vm._s(_vm.pathSettingNameMsg))])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("数据统计：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pathSetting.type),
      expression: "pathSetting.type"
    }],
    attrs: {
      "disabled": _vm.steplist.length > 0,
      "options": _vm.availableOptions
    },
    domProps: {
      "value": (_vm.pathSetting.type)
    },
    on: {
      "input": function($event) {
        _vm.pathSetting.type = $event
      }
    }
  }), _c('v-tooltip', {
    attrs: {
      "tip": "选择按访问统计，则记录一次访问内完成路径的用户的行为数据；选择按天统计，则记录一天内完成路径的用户的行为数据",
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("转化路径：")]), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stepAddlist.length < 5 && _vm.steplist.length == 0),
      expression: "stepAddlist.length < 5 && steplist.length == 0"
    }],
    staticClass: "btn",
    class: _vm.addStepInfoClass,
    on: {
      "click": _vm.addNewStep
    }
  }, [_vm._v("添加步骤")]), _c('table', {
    staticClass: "data-table",
    staticStyle: {
      "table-layout": "fixed",
      "max-width": "800px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "7%"
    }
  }, [_vm._v("步骤")]), _c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("步骤名称")]), _c('th', {
    attrs: {
      "width": "36%"
    }
  }, [_vm._v("页面URL")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("事件ID")]), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steplist.length == 0),
      expression: "steplist.length == 0"
    }],
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("操作")])])]), _c('tbody', [_vm._l((_vm.steplist), function(detail) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.steplist.length > 0),
        expression: "steplist.length > 0"
      }]
    }, [_c('td', [_vm._v(_vm._s(detail.step_seq))]), _c('td', [_vm._v(_vm._s(detail.name))]), _c('td', {
      attrs: {
        "title": detail.url
      }
    }, [_vm._v(_vm._s(detail.url))]), _c('td', [_vm._v(_vm._s(detail.eventid))])])
  }), _vm._l((_vm.stepAddlist), function(detail, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stepAddlist.length > 0),
        expression: "stepAddlist.length > 0"
      }]
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), (!_vm.stepAddabled(detail)) ? _c('td', [_vm._v(_vm._s(detail.name))]) : _vm._e(), (_vm.stepAddabled(detail)) ? _c('td', {
      staticClass: "form-msg"
    }, [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.stepName),
        expression: "stepName"
      }],
      ref: "stepname",
      refInFor: true,
      staticClass: "size-small",
      attrs: {
        "placeholder": "请输入步骤名称",
        "rules": _vm.rules.stepname
      },
      domProps: {
        "value": (_vm.stepName)
      },
      on: {
        "input": function($event) {
          _vm.stepName = $event
        }
      }
    })], 1) : _vm._e(), (!_vm.stepAddabled(detail)) ? _c('td', {
      attrs: {
        "title": detail.url
      }
    }, [_vm._v(_vm._s(detail.url))]) : _vm._e(), (_vm.stepAddabled(detail)) ? _c('td', {
      staticClass: "form-msg"
    }, [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.stepUrl),
        expression: "stepUrl"
      }],
      ref: "stepurl",
      refInFor: true,
      attrs: {
        "placeholder": "请输入URL如：http://fenxi.com，可通配",
        "rules": _vm.rules.url
      },
      domProps: {
        "value": (_vm.stepUrl)
      },
      on: {
        "input": function($event) {
          _vm.stepUrl = $event
        }
      }
    })], 1) : _vm._e(), (!_vm.stepAddabled(detail)) ? _c('td', [_vm._v(_vm._s(detail.eventid))]) : _vm._e(), (_vm.stepAddabled(detail)) ? _c('td', [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.stepEventid),
        expression: "stepEventid"
      }],
      staticClass: "size-small",
      attrs: {
        "placeholder": "非必填"
      },
      domProps: {
        "value": (_vm.stepEventid)
      },
      on: {
        "input": function($event) {
          _vm.stepEventid = $event
        }
      }
    })], 1) : _vm._e(), _c('td', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.stepAddabled(detail)),
        expression: "stepAddabled(detail)"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.saveStep(detail)
        }
      }
    }, [_vm._v("保存")]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delStep(index)
        }
      }
    }, [_vm._v("删除")]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0 && !_vm.stepAddabled(detail)),
        expression: "index == 0 && !stepAddabled(detail)"
      }],
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delStep(index)
        }
      }
    }, [_vm._v("删除")])])])
  })], 2)])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steplist.length == 0),
      expression: "steplist.length == 0"
    }],
    staticClass: "item"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("若转化步骤为某页面的浏览量，则不用填写事件ID；若转化步骤为某点击事件，则既需要填写页面URL也需要填写事件ID。")]), _c('a', {
    staticClass: "btn",
    attrs: {
      "target": "_blank",
      "href": "https://fenxi.360.cn/help/manual?target=conversion"
    }
  }, [_vm._v("详见如何获取ID")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.steplist.length == 0),
      expression: "steplist.length == 0"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.stepAddlist.length < 2
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepInfoSubmit($event)
      }
    }
  }, [_vm._v("确认")]), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepInfoReset($event)
      }
    }
  }, [_vm._v("清空")])])])])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("转化路径名称 ")]), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("创建时间")]), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("操作 ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "noresult",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("暂无相关数据")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a5ef97f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a5ef97f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/path.vue
// module id = 757
// module chunks = 0